export class LogInModel{
    public constructor( ) {
         
    }
    phone:string;
    acountId: string;
    sms: string;
    msgType: string;
    encryptedData : string
}